import axios from "../../axios";

const getBanks = async function (accessToken) {
    try {
        const response = await axios.get('proxy/getBanks', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500
        }
    }
}

export default getBanks;

